<script lang="ts" setup>
import PrintingOrderForm from "@/data-views/forms/printing_order/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "PrintingOrder",
  },
});
</script>

<template>
  <div>
    <PrintingOrderDeprecationNotice />
    <PrintingOrderForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
